// Please keep in sync with src/baserow/contrib/database/fields/constants.py::5
export const RESERVED_BASEROW_FIELD_NAMES = ['id', 'order']
export const MAX_FIELD_NAME_LENGTH = 255

// Please keep in sync with
// src/baserow/contrib/database/api/views/grid/serializers.py:15:PUBLIC_PLACEHOLDER_ENTITY_ID
export const PUBLIC_PLACEHOLDER_ENTITY_ID = 0
